module.exports = __webpack_public_path__ + "img/img-1.9fba0c20.png";